module.exports = __webpack_public_path__ + "img/32-r.ee026492.png";